import { render, staticRenderFns } from "./clientLogoTwo.svg.vue?vue&type=template&id=a6fadb20&scoped=true&"
import script from "./clientLogoTwo.svg.vue?vue&type=script&lang=js&"
export * from "./clientLogoTwo.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fadb20",
  null
  
)

export default component.exports